// Clan des Chineurs - Nav reorder
// Ordre voulu: gauche = [Custom Vintage, Classique Vintage] | droite = [Made in Paris, Bleu de Chine]
document.addEventListener('DOMContentLoaded', function() {
  var DESIRED_ORDER = [
    "Custom Vintage Levi\u2019s 501",
    "Classique Vintage",
    "Made in Paris",
    "Bleu de Chine"
  ];
  var navLists = document.querySelectorAll('.header__inline-menu .list-menu--inline');
  navLists.forEach(function(ul) {
    var items = Array.from(ul.querySelectorAll('li'));
    var reordered = [];
    DESIRED_ORDER.forEach(function(name) {
      var item = items.find(function(li) {
        return li.textContent.trim().toLowerCase().includes(name.toLowerCase().split(' ').slice(0,2).join(' '));
      });
      if (item) reordered.push(item);
    });
    // Ajouter les items non trouvés à la fin (au cas où)
    items.forEach(function(li) {
      if (!reordered.includes(li)) reordered.push(li);
    });
    reordered.forEach(function(li) { ul.appendChild(li); });
  });
});